import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ForumsService } from 'src/app/services/forums.service';
import { LanguageService } from 'src/app/services/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.scss'
})
export class EditComponent {
  public loading: boolean = false;
  protected editorApiKey: string = environment.tinyMceEditorApiKey;
  public forumForm: FormGroup;
  public slug: string;
  public language = this.languageService.getLanguage();
  public titleField = this.language === 'es' ? 'title' : 'title_en';
  public contentField = this.language === 'es' ? 'content' : 'content_en';
  public translationTitleField = this.language === 'es' ? 'title_en' : 'title';
  public translationContentField = this.language === 'es' ? 'content_en' : 'content';
  public enableTranslationFields: boolean = false;
  protected editorConfiguration: any = {
    selector: 'editor',
    relative_urls: false,
    menubar: false,
    plugins: `code quickbars link autosave 
    image lists fullscreen table `,
    toolbar: [`undo redo|restoredraft| bold italic underline blocks | code alignleft aligncenter 
    alignjustify alignright blockquote | bullist numlist`,
      ` link image  print  subscript superscript | fullscreen`],
    autosave_interval: '15s',
    // autosave_prefix: 'tinymce-autosave-{path}{query}-{id}-',
    autosave_restore_when_empty: true,
    autosave_retention: '45m',
    paste_merge_formats: true,
    // paste_preprocess: (editor:any, args:any) => {args.content = args.content.replaceAll(/style="(.*?)"/g,'');},
    paste_preprocess: (editor: any, args: any) => {
      args.content = args.content.replaceAll(
        `/(font-family:(.*?);)
        |(font-size:(.*?);)
        |(line-height:(.*?);)
        |(color:(.*?);)
        |(white-space:(.*?);)
        |(aria-level="(.*?)")/g`, '');
    },
    inline_styles: false,
    file_picker_types: 'image',
    link_default_target: '_blank',
    quickbars_image_toolbar: 'alignleft aligncenter alignright | rotateleft rotateright | imageoptions',
    quickbars_insert_toolbar: 'quickimage quicktable | link | hr | blocks',
    // images_upload_handler: (blobInfo:any,progress:Function) => this.editorImagesSubmition(blobInfo,progress),
  };

  public isAdmin:boolean = JSON.parse(localStorage.getItem('user')).is_admin;

  constructor(private fb: FormBuilder,
    private languageService: LanguageService,
    private forumsService: ForumsService,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.route.params.subscribe(params => {
      this.slug = params['id'];
    });
    this.forumForm = this.fb.group({
      title: [''],
      content: [''],
      title_en: [''],
      content_en: ['']
    });
  }

  ngOnInit(): void {
    this.getResource();
  }

  getResource() {
    this.loading = true;
    this.forumsService.getResource(this.slug).subscribe({
      next: response => {
        // this.forum = response;
        this.forumForm.controls['title'].setValue(response.title);
        this.forumForm.controls['content'].setValue(response.content);
        this.forumForm.controls['title_en'].setValue(response.title_en);
        this.forumForm.controls['content_en'].setValue(response.content_en);
        this.loading = false;
      },
      complete: () => {},
      error: error => {
        console.log("GetResourceError: ", error);
        this.loading = false;
      }
    });
  }

  updateEntry() {
    console.log(this.forumForm.controls);
    this.loading = true;
    this.forumsService.updateResource(this.slug, this.forumForm.value).subscribe({
      next: response => {
        this.forumForm.reset();
        this.loading = false;
        this.toastr.success($localize`:@@forum_update_success:Entrada actualizada con éxito.`);
        window.location.href = `/platform/forum/${response.slug}`;
      },
      complete: () => { },
      error: error => {
        this.loading = false;
        this.toastr.error($localize`:@@forum_update_error:Hubo un error al intentar actualizar la entrada.`);
        console.log('AddResourceError: ', error);
      }
    });
  }

  enableTranslation() {
    console.log('enableTranslation');
    this.enableTranslationFields = !this.enableTranslationFields;
  }
}
